module.exports = __webpack_public_path__ + "static/media/lincoln-phone.50c70940.svg";